import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import Util from '../../util/funcoes.js';

import { ESTADOS, STATUS_CONTA, TIPO_CONTA, BANCOS } from '../../util/constantes';

import AppGravarContaDialog from './dialogs/GravarContaDialog.vue'

export default {
  components: {
    AppGravarContaDialog
  },

  data() {
    return {
      infiniteLoadingId: 0,
      validacao: {
        nome: [
          { required: true, message: "Nome é obrigatório" }
        ],
        cnpj: [
          { required: true, message: "CPF/CNPJ é obrigatório", validator: this.validadorCpfCnpj }
        ]
      },

      tabSelecionada: 'detalhes',

      visibilidadeGravarContaDialog: false,
      
      contaBancariaEmEdicao: undefined,

      hoverGravar: false,
      hoverRemover: false,
    }
  },
  computed: {
    ...mapState('loginStore', {
      permissoes(state) {
        return state.usuarioLogado.permissoes
          .filter((permissao) => {
            return permissao.modulo === "FORNECEDORES"
          })[0];
      }
    }),
    ...mapState('fornecedoresStore', {
      fornecedores(state) { return state.listaFornecedores },
      fornecedorPesquisa(state) { return state.fornecedorPesquisa },
      labelQuantidade(state) { return state.labelQuantidade },
      fornecedor(state) { return state.fornecedorSelecionado }
    }),
    exibirBotaoNovoFornecedor() {
      return this.permissoes.alteracao === true;
    },
    exibirBotaoGravarFornecedor() {
      return(
        (this.fornecedor.id === 0 && this.permissoes.cadastro)
        || (this.fornecedor.id !== 0 && this.permissoes.alteracao)
      )
    },
    exibirBotaoRemoverFornecedor() {
      return this.fornecedor.id != 0 && this.permissoes.remocao;
    },
    estados() { 
      return ESTADOS;
    },
    statusConta() {
      return STATUS_CONTA;
    },
    tiposConta() {
      return TIPO_CONTA;
    },
    bancos() {
      return BANCOS;
    },

    maskCpfCnpj(){
      if(this.fornecedor.personalidadeJuridica == 'PESSOA_JURIDICA') {
        return '##.###.###/####-##'
      } else {
        return '###.###.###-##'
      }
    },

    exibirRazaoSocial() { return this.fornecedor.personalidadeJuridica == 'PESSOA_JURIDICA' },

    isFornecedorSelecioado() {
      return this.fornecedor.id != 0;
    },

    exibirBotaoNovaConta() {
      return this.tabSelecionada === 'contasBanacarias'
    }
   },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('fornecedoresStore', [
      'listarFornecedores',
      'limparFornecedoresListadas',
      'limparFornecedorPesquisa',
      'recuperarFornecedor',
      'novoFornecedor',
      'gravarFornecedor',
      'removerFornecedor',
      'removerConta'
    ]),

    cpfIsValido(cpf) {
      return Util.validarCpf(cpf);
    },

    cnpjIsValido(cnpj) {
      if (!cnpj) return false;

      return cnpj.length === 18;
    },

    validadorCpfCnpj(rule, value, callback) {
      if (this.fornecedor.personalidadeJuridica == 'PESSOA_FISICA') {
        if (this.cpfIsValido(value)) {
          return callback();
        } else {
          return callback(new Error());
        }
      } else {
        if (this.cnpjIsValido(value)) {
          return callback();
        } else {
          return callback(new Error());
        }
      }
    },
    
    pesquisarHandler() {
      this.fornecedorPesquisa.pagina = 0;
      this.limparFornecedoresListadas();
      this.infiniteLoadingId += 1;
    },
    pesquisar($state) {
      if(this.fornecedorPesquisa.pagina === 0) { this.showLoading(); }

      this.listarFornecedores(this.fornecedorPesquisa).then((resultado) => {
        if(this.fornecedorPesquisa.pagina === 0) { this.hideLoading(); }
        if(resultado.lista.length == 100) {
          this.fornecedorPesquisa.pagina += 1;
          $state.loaded();
        } else if(resultado.lista.length > 0 && this.fornecedorPesquisa.pagina == 0) {
          $state.loaded();
          $state.complete();
        } else {
          $state.complete();
        }
      }).catch(() => {
        if(this.fornecedorPesquisa.pagina === 0) { this.hideLoading(); }
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    limparPesquisa() {
      this.limparFornecedorPesquisa();
    },

    novo() {
      this.novoFornecedor();
      this.tabSelecionada = 'detalhes';
    },

    selecionarTab(tab) {
      if(tab.name === 'logs') {
        this.handleRecuperarLogs();
      }
    },

    recuperarHandler(fornecedor) {
      this.recuperar(fornecedor);
    },
    recuperar(fornecedor) {
      this.showLoading();
      this.recuperarFornecedor(fornecedor).then(() => {
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    gravarHandler() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          this.gravar();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      })
    },
    gravar() {
      this.showLoading();
      this.gravarFornecedor(this.fornecedor).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },
    removerHandler() {
      this.$confirm('Deseja realmente remover este Fornecedor?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning',

      }).then(() => {
        this.remover();
      });
    },
    remover() {
      this.showLoading();
      this.removerFornecedor(this.fornecedor).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    editarContaBancaria(conta) {
      this.contaBancariaEmEdicao = Object.assign({}, conta);
      this.showLoading();
      this.visibilidadeGravarContaDialog = true;
      this.hideLoading();
    },

    exibirGravarContaDialog() {
      this.contaBancariaEmEdicao = undefined;
      this.visibilidadeGravarContaDialog = true
    },
    fecharGravarContaDialog() {
      this.visibilidadeGravarContaDialog = false;
    },

    removerContaBancariaHandler(conta) {
      this.$confirm('Deseja realmente remover esta conta bancária do cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.removerContaBancaria(conta);
      }).catch(() => { });
    },

    removerContaBancaria(conta) {
      this.showLoading();
      this.removerConta(conta)
      .then((resultado) => {
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).finally(() => { this.hideLoading(); })
    },

    formatarString(str) {
      str = str.split('_');
      for (var i = 0, x = str.length; i < x; i++) {
        str[i] = str[i][0].toUpperCase() + str[i].substr(1).toLowerCase();
      }
      return str.join(" ");
    },

    getLabel(array, element) {
      return Util.getLabel(array, element);
    },
  }
}